var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dataview-chart",
      class: { "loading-graph": _vm.isLoading },
    },
    [
      _c(
        "div",
        { staticClass: "grid-50w filters" },
        _vm._l(_vm.filters, function (filter) {
          return _vm.filters
            ? _c("treeselect", {
                key: filter.instanceId,
                attrs: {
                  multiple: _vm.isMultiple(filter),
                  clearable: _vm.isMultiple(filter),
                  options: filter.values,
                  placeholder: filter.name,
                  instanceId: filter.instanceId,
                },
                on: { close: _vm.filterChanged, input: _vm.filterChanged },
                model: {
                  value: _vm.filterValues[filter.instanceId],
                  callback: function ($$v) {
                    _vm.$set(_vm.filterValues, filter.instanceId, $$v)
                  },
                  expression: "filterValues[filter.instanceId]",
                },
              })
            : _vm._e()
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { ref: "eventMapElement", staticClass: "mapview" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }